export const GlobalAlertSuccess = 'GLOBAL_ALERT_SUCCESS';

export function setGlobalAlertAction(data) {
  return {
    type: GlobalAlertSuccess,
    payload: data,
  };
}
